import React, { useEffect, useState } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import config from '../../config'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useStripe } from '@stripe/react-stripe-js'
import { StyleSheet, css } from 'aphrodite'
import { COLOR_ERROR, COLOR_WHITE, COLOR_BLACK } from '../../lib/colors'
import UIButton from '../UI/UIButton'
import WidgetMakerHeader from '../../components/Widget/WidgetMakerHeader'
import { MEDIA_MIN_SM } from '../../lib/breakpoints'

const stripePromise = loadStripe(config.REACT_APP_STRIPE_PB)

const StatusPayments = () => {
  const clientSecret = localStorage.getItem('clientSecret')
  return (
    <>
      <WidgetMakerHeader
        handleBecomeMakerClick={() => {}}
        handleGlobeClick={function noRefCheck() {}}
      />
      <Elements stripe={stripePromise} options={{ clientSecret }}>
        <Status />
      </Elements>
    </>
  )
}

const Status = () => {
  const stripe = useStripe()

  const { t } = useTranslation('translation')

  const [messageStatus, setMessageStatus] = useState(null)
  const [status, setStatus] = useState('failed')

  const navigate = useNavigate()

  const successRedirect = () => {
    navigate('/account/demand')
  }

  const failedRedirect = () => {
    navigate('/payments')
  }

  useEffect(() => {
    ;(async () => {
      const clientSecret = new URLSearchParams(window.location.search).get(
        'payment_intent_client_secret'
      )

      if (!clientSecret) {
        return
      }

      let response
      if (stripe) {
        try {
          response = await stripe.retrievePaymentIntent(clientSecret)
        } catch (error) {
          console.log('errors : ', error)
        }

        switch (response.paymentIntent.status) {
          case 'requires_capture':
            setMessageStatus(t('pages.payments.paymentExecutedLater'))
            setStatus('success')
            break
          case 'succeeded':
            setMessageStatus(t('pages.payments.paymentSucceeded'))
            setStatus('success')
            break
          case 'processing':
            setMessageStatus(t('pages.payments.paymentProcessing'))
            setStatus('success')
            break
          case 'requires_payment_method':
            setMessageStatus(t('pages.payments.paymentNotSuccessful'))
            setStatus('failed')
            break
          default:
            setMessageStatus(t('pages.payments.unexpectedError'))
            setStatus('failed')
            break
        }
      }
    })()
  }, [stripe])
  return (
    <div className={css(styles.container)}>
      {messageStatus && (
        <div
          className={css(
            styles.containerStatus,
            status === 'failed' ? styles.failedMessage : styles.successMessage
          )}
        >
          {status === 'failed' ? (
            <p>{messageStatus}</p>
          ) : (
            <>
              <p className={css(styles.title)}>{t('pages.payments.done')}</p>
              <p className={css(styles.title)}>{t('pages.payments.done2')}</p>
              <p>{t('pages.payments.nextStep')}</p>
              <ol className={css(styles.list)}>
                <li>{t('pages.payments.step1')}</li>
                <li>{t('pages.payments.step2')}</li>
                <li>{t('pages.payments.step3')}</li>
                <li>{t('pages.payments.step4')}</li>
              </ol>
            </>
          )}
          <p></p>
        </div>
      )}
      <UIButton
        label={
          status === 'failed'
            ? t('common.button.back')
            : t('pages.payments.back')
        }
        onClick={status === 'failed' ? failedRedirect : successRedirect}
        design="primary"
        dynamicStyle={styles.button}
      />
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '60vh',
    overflow: 'hidden',
    fontFamily: 'Helvetica',
    padding: 10,
  },
  containerStatus: {
    padding: '1em 2em',
    borderRadius: '20px',
    fontSize: '1.5em',
    color: COLOR_WHITE,
    marginBottom: '1.5em',
    [MEDIA_MIN_SM]: {
      padding: '1em 6em',
    },
  },
  title: {
    textAlign: 'center',
    fontWeight: 'bold',
    margin: 0,
    fontSize: 11,
    [MEDIA_MIN_SM]: {
      fontSize: 24,
    },
  },
  successMessage: {
    background:
      'linear-gradient(48.29deg, rgba(185, 170, 0, 0.4) 15.95%, rgba(184, 171, 0, 0.4) 22.79%, rgba(178, 173, 32, 0.4) 33.69%, rgba(165, 176, 77, 0.4) 47.29%, rgba(131, 176, 124, 0.4) 63.05%, rgba(8, 171, 175, 0.4) 80.42%, rgba(0, 166, 205, 0.4) 90.45%)',
    color: COLOR_BLACK,
    fontSize: 10,
    [MEDIA_MIN_SM]: {
      fontSize: 15,
    },
  },
  failedMessage: {
    backgroundColor: COLOR_ERROR,
  },
  button: {
    borderRadius: 50,
    width: 'calc(100% - 20px)',
    justifyContent: 'center',
    padding: '12px 0',
    [MEDIA_MIN_SM]: {
      borderRadius: 4,
      padding: '16px 24px',
      width: 'unset',
    },
  },
  list: {
    paddingLeft: 16,
  },
})

export default StatusPayments
